import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/ebay-multiuser-account-access';

export default function Example() {
  return (
    <>
      <Head>
        <title>eBay Multi-User Account Access: What is it, and why is it essential in growing your business?</title>
        <meta
          name='description'
          content='Having extra hands in running your eBay store is great, but making use of a feature that provides you with flexibility in delegating tasks is even better. Know all about this feature in this article.'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/ebay-multiuser-account-access' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/ebay-multiuser-account-access' />
        <meta
          property='og:title'
          content='eBay Multi-User Account Access: What is it, and why is it essential in growing your business?'
        />
        <meta
          property='og:description'
          content='Having extra hands in running your eBay store is great, but making use of a feature that provides you with flexibility in delegating tasks is even better. Know all about this feature in this article.'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='April 8th, 2022' />
        <meta property='article:modified_time' content='April 8th, 2022' />
        <meta property='article:tag' content='eBay' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
